import { useEffect, useState } from "react";
import { Box, Grid, Link as MuiLink } from "@mui/material";
import { AdsService } from "../../../api/services/ads";

interface AdItem {
  id: number;
  image_url: string;
  link_url: string;
  alt_text: string;
  open_in_new_tab: boolean;
}

// Fetches sponsor banners for a given placement (see PLACEMENT_CHOICES in
// the backend's ads.models.Ad) so they can be swapped/disabled from Django
// Admin without a frontend deploy. Renders nothing while empty/loading -
// callers don't need to handle that themselves.
const AdSlot = ({ placement }: { placement: string }) => {
  const [ads, setAds] = useState<AdItem[]>([]);

  useEffect(() => {
    AdsService.requestAds(placement)
      .then((res) => setAds(res.data.data))
      .catch(console.log);
  }, [placement]);

  if (ads.length === 0) {
    return null;
  }

  // A single ad always fills the full width - only split into columns
  // (and only on tablet/desktop) when there's more than one to show side
  // by side.
  const itemWidth = ads.length > 1 ? 6 : 12;

  return (
    <Box sx={{ mt: 2 }}>
      <Grid container spacing={2}>
        {ads.map((ad) => (
          <Grid item xs={12} sm={itemWidth} key={ad.id}>
            <Box
              component="a"
              href={ad.link_url}
              title={ad.alt_text}
              target={ad.open_in_new_tab ? "_blank" : undefined}
              rel={ad.open_in_new_tab ? "noreferrer noopener" : undefined}
              sx={{ display: "block" }}
            >
              <Box
                component="img"
                src={ad.image_url}
                title={ad.alt_text}
                alt={ad.alt_text}
                sx={{ display: "block", width: "100%", borderRadius: 1 }}
              />
            </Box>
          </Grid>
        ))}
      </Grid>
      <MuiLink
        href="https://leipapa.com/advertising"
        title="Contact LEIpapa for advertising"
        variant="caption"
        sx={{ display: "block", textAlign: "right", mt: 0.5 }}
      >
        Advertise on LEIpapa
      </MuiLink>
    </Box>
  );
};

export default AdSlot;
